<div class="tablewrap">
  <div class="table">
    <table fixedcols="[1]">
      <tr>
        <th style="max-width: 150px">{{'Name'|translate}}</th>
        <th>{{'Overriden ID'|translate}}</th>
        <th>
          <button class="btn_img btn_graygray btn_plusorange" (click)="onAddObjectClick()" title="{{'Add'|translate}}"></button>
          <button class="btn_img btn_remove" (click)="onRemoveAllClick()" title="{{'Clear'|translate}}"></button>
        </th>
      </tr>
      <tr *ngFor="let item of model.Objects">
        <td class="name">{{Objects?.get(item.ObjectId).Name}}</td>
        <td>
          <input type="text"
                 [defaultValue]="item.OverridenId ?? ''"
                 (change)="overridenIdChange($event, item)"
          />
        </td>
        <td><button class="btn_img btn_remove" (click)="removeObject(item.ObjectId)"></button></td>
      </tr>
    </table>
  </div>
</div>
<template #objectsListDialog></template>
